import { useState } from 'react'

import clsx from 'clsx'

import { AppIcon } from 'shared/ui/app-icon'
import { AllIcons } from 'shared/ui/app-icon/types'

import styles from './styles.module.scss'

const MAX_COUNT = 9

interface Props {
  maxNumber?: number
  minNumber?: number
  onChange?: (count: number) => void
  title?: string
  subTitle?: string
  value?: number
  alignCenter?: boolean
}

export const ButtonInput = ({
  title,
  subTitle,
  value = 0,
  onChange,
  minNumber = 0,
  maxNumber = MAX_COUNT,
  alignCenter,
}: Props) => {
  const [count, setCount] = useState(value)

  const onChangeHandler = (num: number) => {
    if (minNumber <= num && maxNumber >= num) {
      onChange && onChange(num)
      setCount(num)
    }
  }

  return (
    <div className={clsx(styles.container, alignCenter && styles.alignCenter)}>
      <div className={styles.left}>
        <p>{title}</p>
        <span>{subTitle}</span>
      </div>

      <div className={styles.right}>
        <div
          className={styles.button}
          onClick={() => onChangeHandler(count - 1)}
        >
          <AppIcon
            id={AllIcons.MINUS}
            height={16}
            width={16}
            className={clsx(
              count <= minNumber ? styles.inActive : styles.minusIcon,
            )}
          />
        </div>
        <div className={styles.count}>{count}</div>
        <div
          className={styles.button}
          onClick={() => onChangeHandler(count + 1)}
        >
          <AppIcon
            id={AllIcons.PLUS}
            height={16}
            width={16}
            className={clsx(count >= maxNumber ? styles.inActive : styles.icon)}
          />
        </div>
      </div>
    </div>
  )
}
